export const defaultDebounceDelay = 300;
export const defaultAverageCapacity = 8;
export const defaultAccountTotalCapacity = 40;
